var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
export class DynamicGalleryComponent extends Component {
    constructor() {
        super('TestComponent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.open-dynamic-gallery').on('click', (event, item) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                var images = yield $.httpRequest({
                    url: '?gallery=' + (parseInt($(item).data('index')) - 1),
                    dataType: 'json',
                });
                lightGallery(item, {
                    dynamic: true,
                    dynamicEl: images,
                    download: false,
                    counter: true,
                    hideBarsDelay: 0,
                    thumbnail: false,
                    mode: 'lg-fade',
                    loop: false,
                    enableSwipe: true,
                });
            }));
            if (location.hash) {
                $('.open-dynamic-gallery[data-index="' + location.hash.replace('#', '') + '"]').trigger('click');
            }
            this.success();
        });
    }
}
